/** @file createT: builds a translate function with language fallback to English and {param} interpolation. */
import type { Catalog, CatalogKey, PartialCatalog, Translate } from './types';

type Node = string | { [k: string]: Node | undefined } | undefined;

function lookup(root: Node, key: string): string | undefined {
  let node: Node = root;
  for (const part of key.split('.')) {
    if (node === undefined || typeof node === 'string') return undefined;
    node = node[part];
  }
  return typeof node === 'string' ? node : undefined;
}

/** `catalogs.en` must be complete; other languages may be partial. Unknown `lang` behaves like `en`. */
export function createT(catalogs: { en: Catalog } & Record<string, PartialCatalog>, lang: string): Translate {
  const primary = catalogs[lang] as Node;
  const fallback = catalogs.en as Node;
  return (key: CatalogKey, params?: Record<string, string | number>): string => {
    const text = lookup(primary, key) ?? lookup(fallback, key) ?? key;
    return params ? text.replace(/\{(\w+)\}/g, (_, k: string) => String(params[k] ?? `{${k}}`)) : text;
  };
}
